// src/extenders/highlighted-links.js
var HighlightedLinks = class extends HTMLElement {
  constructor() {
    super();
    this.subjects = this.querySelectorAll(".js-highlights-subject");
    this.highlights = this.querySelectorAll(".js-highlight");
    this.subjects.forEach((subject) => {
      subject.addEventListener("click", () => this.changeHighlight(subject));
    });
    this.initializeFirstHighlight();
  }
  changeHighlight(selectedSubject) {
    this.subjects.forEach((subject) => {
      subject.setAttribute("aria-expanded", "false");
    });
    selectedSubject.setAttribute("aria-expanded", "true");
    const targetId = selectedSubject.getAttribute("aria-controls");
    this.highlights.forEach((highlight) => {
      const isMatch = highlight.getAttribute("aria-labelledby") === targetId;
      highlight.classList.toggle("hidden", !isMatch);
      highlight.classList.toggle("block", isMatch);
    });
  }
  initializeFirstHighlight() {
    if (this.subjects.length > 0) {
      this.changeHighlight(this.subjects[0]);
    }
  }
};
if (customElements.get("highlighted-links") === void 0) {
  customElements.define("highlighted-links", HighlightedLinks);
}
